import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ModuleFE_MeasurementUnit, ModuleFE_Value, ModuleFE_Variable } from '@app/hcs-frontend';
import { ComponentSync, LL_H_C, LL_V_L, TS_AppTools, TS_PropRenderer } from '@nu-art/thunderstorm-frontend/index';
import './ATS_Tooltip_Finding.scss';
import { _values } from '@nu-art/ts-common';
import { FindingTooltipEnumTests } from './enumerated.js';
import { FindingTooltipNumericTests } from './numeric.js';
import { FindingTooltipTextualTests } from './textual.js';
import { Tooltip_Finding_Enum, Tooltip_Finding_Numeric, Tooltip_Finding_Textual } from '../tooltip/index.js';
const modules = {
    variable: ModuleFE_Variable,
    value: ModuleFE_Value,
    measurementUnit: ModuleFE_MeasurementUnit,
};
class ATS_Tooltip_Finding_Component extends ComponentSync {
    render() {
        return _jsxs(LL_V_L, { id: 'ats__tooltip-finding', children: [TS_AppTools.renderPageHeader('Findings Tooltip'), _jsxs(LL_H_C, { id: 'ats__tooltip-finding__main', children: [this.render_EnumFindings(), this.render_NumericFindings(), this.render_TextualFindings()] })] });
    }
    render_EnumFindings = () => {
        return _jsx(TS_PropRenderer.Vertical, { label: 'Enumerated Findings', children: FindingTooltipEnumTests().map(test => {
                return _jsx(Tooltip_Finding_Enum, { modules: modules, data: test.data, children: _jsx("div", { className: 'finding-tooltip-test', children: test.label }) }, test.label);
            }) });
    };
    render_NumericFindings = () => {
        return _jsx(TS_PropRenderer.Vertical, { label: 'Numeric Findings', children: FindingTooltipNumericTests().map(test => {
                return _jsx(Tooltip_Finding_Numeric, { modules: modules, data: test.data, children: _jsx("div", { className: 'finding-tooltip-test', children: test.label }) }, test.label);
            }) });
    };
    render_TextualFindings = () => {
        return _jsx(TS_PropRenderer.Vertical, { label: 'Textual Findings', children: FindingTooltipTextualTests().map(test => {
                return _jsx(Tooltip_Finding_Textual, { modules: modules, data: test.data, children: _jsx("div", { className: 'finding-tooltip-test', children: test.label }) }, test.label);
            }) });
    };
}
export const ATS_Tooltip_Finding = {
    key: 'ats__tooltip-finding',
    modulesToAwait: _values(modules),
    renderer: ATS_Tooltip_Finding_Component,
    name: 'Findings Tooltip'
};
//# sourceMappingURL=ATS_Tooltip_Finding.js.map